import React, { Component, ComponentType } from "react";

import { connect } from "react-redux";

import { track } from "../../lib/track";

import { Callback, RootState, SettingState, UserDataState } from "../../types";
import { ReceiptData } from "../../types/Payment/ReceiptData";

import { getReceipts } from "./action";
import { getCurrentUserState } from "../User/selector";
import { getSettingState } from "../Setting/selector";
import { getReceiptDataState, getReceiptDataHasMoreState } from "./selector";

type StateProps = {
  user: UserDataState | {};
  setting: SettingState | {};
  data: ReceiptData[] | null;
  hasMore: boolean;
};

export type ReceiptsLayoutProps = {
  error: string | null;
  loading: boolean;
  refreshing: boolean;
  hasMore: boolean;
  user: {} | UserDataState;
  setting: {} | SettingState;
  data: ReceiptData[] | null;
  reFetch: (next: boolean, refresh: boolean, callback?: Callback) => void;
};

type Props = {
  Layout: ComponentType<ReceiptsLayoutProps>;
  getReceipts: (next: boolean, refresh: boolean) => Promise<void>;
} & StateProps;

type State = {
  error: string | null;
  loading: boolean;
  refreshing: boolean;
};

class Receipts extends Component<Props, State> {
  state: State = {
    error: null,
    loading: false,
    refreshing: false,
  };

  componentDidMount(): void {
    this.fetchData(false, true);

    track("View Screen", {
      Screen: "payment-receipts",
    });
  }

  fetchData = (
    next: boolean,
    refresh: boolean,
    callback?: () => void
  ): void => {
    const { getReceipts, data } = this.props;
    const { refreshing, loading } = this.state;
    if (refreshing || loading) {
      return;
    }

    this.setState(
      { refreshing: refresh && !!data, loading: next },
      async () => {
        try {
          await getReceipts(next, refresh);
          this.setState({
            loading: false,
            refreshing: false,
            error: null,
          });
          callback && callback();
        } catch (error) {
          this.setState({ loading: false, refreshing: false, error: error });
        }
      }
    );
  };

  render = (): JSX.Element => {
    const { Layout, user, data, setting, hasMore } = this.props;
    const { loading, error, refreshing } = this.state;

    return (
      <Layout
        error={error}
        loading={loading}
        refreshing={refreshing}
        hasMore={hasMore}
        user={user}
        setting={setting}
        data={data}
        reFetch={this.fetchData}
      />
    );
  };
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    user: getCurrentUserState(state),
    setting: getSettingState(state),
    data: getReceiptDataState(state),
    hasMore: getReceiptDataHasMoreState(state),
  };
};

const mapDispatchToProps = {
  getReceipts: getReceipts,
};

export default connect(mapStateToProps, mapDispatchToProps)(Receipts);
